import { useEffect, useState } from 'react'
import GymService from 'service/GymService'

// locals
import { IGetGymSalonTimeTableList } from 'types/GymType'
import DateUtil from 'utils/DateUtil'
import { groupBy } from 'utils/Miscellaneous'

export default function useGetGymSalonReservationTable(
  locationId: number,
  selectedSalonId: number,
  dateFromList: Date,
  isCalendar: boolean = false
) {
  const [timeTable, setTimeTable] = useState<IGetGymSalonTimeTableList[] | []>([])
  const selectedDate = DateUtil.getWeekStartEndFromDate(dateFromList)
  const [tableWeek, setTableWeek] = useState(selectedDate)
  const [availableDates, setAvailableDates] = useState({ start: 0, end: 0 })
  const [selectedAppointment, setSelectedAppointment] = useState<IGetGymSalonTimeTableList>()
  const [sidebarVisible, setSidebarVisible] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    GymService.getGymServiceDetailByLocationId(locationId).then((res) =>
      setAvailableDates({
        start: res.data.reservationStartDay,
        end: res.data.reservationEndDay,
      })
    )
  }, [locationId])

  useEffect(() => {
    setLoading(true)
    GymService.getGymSalonReservationTableList({
      gymSaloonId: selectedSalonId,
      startDate: DateUtil.formatDateToString(tableWeek.start),
      endDate: DateUtil.formatDateToString(tableWeek.end),
    })
      .then((res) => setTimeTable(res.data))
      .finally(() => setLoading(false))

    /* Reset selected appointment time */
    if (!isCalendar) setSelectedAppointment(undefined)
  }, [selectedSalonId, tableWeek.start, tableWeek.end, isCalendar])

  useEffect(() => {
    const selectedDate = DateUtil.getWeekStartEndFromDate(dateFromList)
    setTableWeek(selectedDate)
  }, [dateFromList, selectedSalonId])

  const dailyAppointments: [] | Record<string, IGetGymSalonTimeTableList[]> = !!timeTable.length
    ? groupBy(timeTable, (v) => DateUtil.formatStringToDate(v.reservationStartHour))
    : []

  return {
    availableDates,
    tableWeek,
    setTableWeek,
    selectedAppointment,
    setSelectedAppointment,
    sidebarVisible,
    setSidebarVisible,
    dailyAppointments,
    loading,
  }
}
